import { Pipe, PipeTransform } from '@angular/core';
import { CheckListTypeMap } from '../../check-list-type';

@Pipe({
  name: 'checklistType'
})
export class ChecklistTypePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return CheckListTypeMap(value);
  }
}
